import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import CommentHeaderDetails from "./CommentHeaderDetails";
import GeneratedResponse from "./GeneratedResponse";
import ReplyBox from "./ReplyBox";
import CommentItem from "./CommentItem";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { inboxActions } from "_actions";

export default function CommentDetailsContainer({
  conversation,
  currentUser,
  link,
  sourceName,
  author,
  messageId,
  companyReplied,
  markAsDone,
}) {
  const dispatch = useDispatch();
  const [replyText, setReplyText] = useState("");
  const parentPost = useSelector((state) => state.inbox.parentPost);
  const post = _.get(parentPost, "post");
  const organizationName = _.get(currentUser, "_embedded.organization.name");

  useEffect(() => {
    dispatch(inboxActions.getParentPost(messageId));
  }, []);

  return (
    <Box flex={1}>
      <CommentHeaderDetails
        link={link}
        post={post}
        sourceName={sourceName}
        organizationName={organizationName}
      />
      <Box mt={2} mb={2}>
        <CommentItem
          author={author}
          conversation={conversation}
          sourceName={sourceName}
        />
      </Box>
      <Box
        sx={{
          padding: "15px",
          borderTop: "1px solid rgb(241, 237, 230)",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "rgba(18, 38, 27, 0.05) 0px 1px 3px",
        }}
      >
        <Box
          sx={{
            color: "#12261b",
            fontFamily: "FustatExtraBold",
            fontSize: "14px",
            mb: "12px",
          }}
        >
          Reply publicly
        </Box>
        <GeneratedResponse
          draft={conversation?.draft}
          messageId={messageId}
          onUseSuggested={setReplyText}
        />
        <ReplyBox
          link={link}
          conversation={conversation}
          currentUser={currentUser}
          companyReplied={companyReplied}
          markAsDone={markAsDone}
          openedMessageId={messageId}
          replyText={replyText}
          onReplyTextChange={setReplyText}
        />
      </Box>
    </Box>
  );
}
